<template>
	<div class="chat-red-packet">
		<div class="packet" :class="{ opened: bubbleOpened }" @click.stop="onClick">
			<div class="packet-main">
				<div class="packet-seal">¥</div>
				<div class="packet-text">
					<div class="packet-greet">{{ packet.greeting || $t('chat.redPacket.greeting') }}</div>
					<div class="packet-sub">{{ bubbleOpened ? $t('chat.redPacket.opened') : $t('chat.redPacket.label') }}</div>
				</div>
			</div>
			<div class="packet-foot">{{ $t('chat.redPacket.label') }}</div>
		</div>
		<div v-if="show" ref="mask" class="mask" @click.self="close">
			<div class="dialog" @click.stop>
				<div class="cover" :class="{ opened: coverOpened }">
					<div class="nick">{{ detail.senderNickName }}{{ $t('chat.redPacket.from') }}</div>
					<div class="greet">{{ detail.greeting || packet.greeting }}</div>
					<div v-if="showOpen" class="seal" @click="onOpen">{{ $t('chat.redPacket.open') }}</div>
					<div v-else-if="detail.mineAmount != null" class="got">
						<span class="got-num">{{ money(detail.mineAmount) }}</span>
						<span>{{ $t('chat.redPacket.yuan') }}</span>
					</div>
					<div v-else class="hint">{{ hint }}</div>
				</div>
				<div class="link" @click="showDetail = !showDetail">
					{{ showDetail ? $t('chat.redPacket.hideDetail') : $t('chat.redPacket.detail') }}
				</div>
				<div v-if="showDetail" class="records">
					<div class="summary">{{ summaryText }}</div>
					<div v-for="item in records" :key="item.userId" class="row">
						<head-image :url="item.headImage" :name="item.nickName" :size="36"></head-image>
						<div class="meta">
							<div class="name-line">
								<span class="name">{{ item.nickName }}</span>
								<span v-if="item.best" class="best">{{ $t('chat.redPacket.best') }}</span>
							</div>
							<div class="time">{{ formatTime(item.createdTime) }}</div>
						</div>
						<div class="amt">{{ money(item.amount) }}{{ $t('chat.redPacket.yuan') }}</div>
					</div>
				</div>
				<div class="close" @click.stop="close">×</div>
			</div>
		</div>
	</div>
</template>

<script>
import HeadImage from '../common/HeadImage.vue';

const STORAGE_KEY = 'rp-opened';

export default {
	name: 'chatRedPacket',
	components: { HeadImage },
	props: {
		content: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			show: false,
			detail: {},
			loading: false,
			showDetail: false,
			claimed: false
		}
	},
	computed: {
		packet() {
			try {
				return JSON.parse(this.content || '{}');
			} catch (e) {
				return {};
			}
		},
		bubbleOpened() {
			return this.claimed || this.isMarked(this.packet.packetId);
		},
		coverOpened() {
			return this.detail.opened || this.detail.status == 1 || this.detail.status == 2;
		},
		isSender() {
			return this.detail.senderId && this.detail.senderId == this.userStore.userInfo.id;
		},
		showOpen() {
			if (!this.detail.id || this.loading) {
				return false;
			}
			if (this.detail.opened || this.detail.status == 1 || this.detail.status == 2) {
				return false;
			}
			if (this.detail.chatType == 1 && this.isSender) {
				return false;
			}
			return true;
		},
		hint() {
			if (this.detail.status == 2) {
				return this.$t('chat.redPacket.expired');
			}
			if (this.detail.status == 1) {
				return this.$t('chat.redPacket.finished');
			}
			if (this.detail.chatType == 1 && this.isSender) {
				return this.$t('chat.redPacket.wait');
			}
			return '';
		},
		records() {
			return this.detail.records || [];
		},
		summaryText() {
			const total = this.money(this.detail.totalAmount);
			const text = this.$t('chat.redPacket.summary', {
				got: this.records.length,
				count: this.detail.totalCount || 0,
				total
			});
			if (this.detail.chatType == 2 && Number(this.detail.fee) > 0) {
				return text + this.$t('chat.redPacket.fee', { fee: this.money(this.detail.fee) });
			}
			return text;
		}
	},
	watch: {
		show(val) {
			if (!val) {
				return;
			}
			this.$nextTick(() => {
				const mask = this.$refs.mask;
				if (mask && mask.parentNode !== document.body) {
					document.body.appendChild(mask);
				}
			});
		}
	},
	beforeDestroy() {
		const mask = this.$refs.mask;
		if (mask && mask.parentNode === document.body) {
			document.body.removeChild(mask);
		}
	},
	methods: {
		money(value) {
			return Number(value || 0).toFixed(2);
		},
		isMarked(id) {
			if (!id) {
				return false;
			}
			const list = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
			return list.indexOf(id) >= 0;
		},
		markOpened(id) {
			if (!id) {
				return;
			}
			const list = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
			if (list.indexOf(id) < 0) {
				list.push(id);
				localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(-200)));
			}
			this.claimed = true;
		},
		onClick() {
			if (!this.packet.packetId) {
				return;
			}
			this.detail = { greeting: this.packet.greeting };
			this.showDetail = false;
			this.show = true;
			this.$http({
				url: '/redPacket/' + this.packet.packetId,
				method: 'get'
			}).then((data) => {
				this.detail = data || {};
				if (this.detail.opened || this.detail.mineAmount != null) {
					this.markOpened(this.packet.packetId);
				}
			});
		},
		close() {
			this.show = false;
		},
		onOpen() {
			if (this.loading || !this.packet.packetId) {
				return;
			}
			this.loading = true;
			this.$http({
				url: '/redPacket/open/' + this.packet.packetId,
				method: 'post'
			}).then((data) => {
				this.detail = data || {};
				this.markOpened(this.packet.packetId);
			}).finally(() => {
				this.loading = false;
			});
		},
		formatTime(time) {
			if (!time) {
				return '';
			}
			const date = new Date(Number(time));
			const p = (n) => (n < 10 ? '0' + n : '' + n);
			return `${p(date.getMonth() + 1)}-${p(date.getDate())} ${p(date.getHours())}:${p(date.getMinutes())}`;
		}
	}
}
</script>

<style lang="scss" scoped>
.packet {
	width: 240px;
	border-radius: 8px;
	overflow: hidden;
	background: #f25542;
	color: #fff;
	cursor: pointer;
}

.packet.opened {
	background: #f3b7a2;
}

.packet-main {
	display: flex;
	align-items: center;
	padding: 12px 12px 10px;
}

.packet-seal {
	width: 40px;
	height: 40px;
	border-radius: 50%;
	background: #f6d36b;
	color: #a15c12;
	font-size: 18px;
	font-weight: 700;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
}

.packet-text {
	margin-left: 10px;
	min-width: 0;
}

.packet-greet {
	font-size: 15px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	max-width: 160px;
}

.packet-sub {
	margin-top: 4px;
	font-size: 12px;
	opacity: 0.85;
}

.packet-foot {
	padding: 6px 12px;
	font-size: 12px;
	background: rgba(0, 0, 0, 0.08);
}

.mask {
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.55);
	z-index: 4000;
	display: flex;
	align-items: center;
	justify-content: center;
}

.dialog {
	width: 320px;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.cover {
	width: 100%;
	min-height: 360px;
	border-radius: 12px;
	background: linear-gradient(180deg, #f25542 0%, #e4453a 42%, #d63b32 42%, #c4312a 100%);
	color: #ffe7b0;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 40px 20px 28px;
	box-sizing: border-box;
}

.cover.opened {
	background: linear-gradient(180deg, #f3b7a2 0%, #e7a090 42%, #d98b7c 42%, #d08a7c 100%);
}

.nick {
	font-size: 15px;
}

.greet {
	margin-top: 14px;
	font-size: 18px;
	text-align: center;
}

.seal {
	margin-top: 56px;
	width: 84px;
	height: 84px;
	border-radius: 50%;
	background: radial-gradient(circle at 40% 35%, #ffe7a3, #e0b44a 60%, #c7962e);
	color: #7a4b12;
	font-size: 32px;
	font-weight: 700;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
}

.got {
	margin-top: 48px;
	color: #fff8e8;
}

.got-num {
	font-size: 40px;
	font-weight: 600;
	margin-right: 4px;
}

.hint {
	margin-top: 56px;
	font-size: 16px;
	color: #fff;
}

.link {
	margin-top: 14px;
	color: #ffe7b0;
	font-size: 14px;
	cursor: pointer;
}

.records {
	width: 100%;
	max-height: 220px;
	overflow: auto;
	margin-top: 10px;
	background: #fff;
	border-radius: 8px;
	color: #333;
}

.summary {
	padding: 10px 12px;
	color: #999;
	font-size: 12px;
	border-bottom: 1px solid #f0f0f0;
}

.row {
	display: flex;
	align-items: center;
	padding: 10px 12px;
	gap: 8px;
}

.meta {
	flex: 1;
	min-width: 0;
}

.name-line {
	display: flex;
	align-items: center;
	gap: 6px;
}

.name {
	font-size: 14px;
}

.best {
	font-size: 12px;
	color: #e6a23c;
}

.time {
	margin-top: 2px;
	font-size: 12px;
	color: #999;
}

.amt {
	font-size: 14px;
}

.close {
	margin-top: 16px;
	width: 32px;
	height: 32px;
	border: 1px solid #fff;
	border-radius: 50%;
	color: #fff;
	font-size: 22px;
	line-height: 28px;
	text-align: center;
	cursor: pointer;
}
</style>
